/******/ (() => {
  // webpackBootstrap
  var isDefined = customElements.get("localization-form");

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.thing = 0;
        this.cart = null;
        this.fetchCart();

        this.elements = {
          input: this.querySelector(
            'input[name="language_code"],input[name="country_code"],input[name="localization_domain_name"]'
          ),
          button: this.querySelector("button"),
          panel: this.querySelector("ul"),
        };

        this.isDomainForm = this.classList.contains("domain-form");

        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this)
        );

        this.elements.button.addEventListener(
          "blur",
          this.closeSelector.bind(this)
        );

        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        this.elements.panel.querySelectorAll("a").forEach((item) => {
          item.addEventListener("click", this.onItemClick.bind(this));
        });
      }

      fetchCart() {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            this.cart = cart;
          })
          .catch((e) => {
            console.error(e);
          });
      }


      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();

        if (this.isDomainForm) {
          const oldLocalizedDomain = this.elements.input.value;
          const newLocalizedDomain = event.currentTarget.dataset.value;

          if (oldLocalizedDomain === newLocalizedDomain) return;

          let currentUrl = window.location.toString();

          // Remove language codes from the path when switching domains
          // Handle patterns like /fr/, /en/, /es/, etc.
          const languageCodePattern = /\/([a-z]{2})\//;
          if (languageCodePattern.test(currentUrl)) {
            currentUrl = currentUrl.replace(languageCodePattern, "/");
          }

          const newLocation = currentUrl.replace(
            oldLocalizedDomain,
            newLocalizedDomain
          );

          if (
            this.cart &&
            this.cart.cart_level_discount_applications &&
            this.cart.cart_level_discount_applications.length > 0
          ) {
            const discount = this.cart.cart_level_discount_applications[0];
            if (discount && discount.title) {
              try {
                const url = new URL(newLocation);
                window.location.href = `${url.origin}/discount/${
                  discount.title
                }?redirect=${encodeURIComponent(
                  url.pathname + url.search + url.hash
                )}`;
                return;
              } catch (e) {
                console.error("Error constructing discount URL", e);
              }
            }
          }

          window.location.href = newLocation;
        } else {
          const form = this.querySelector("form");
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
      }

      closeSelector(event) {
        const shouldClose =
          !event.relatedTarget?.classList?.contains("disclosure__item_el") &&
          !event.relatedTarget?.classList?.contains("disclosure__item");

        if (shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define("localization-form", LocalizationForm);
  }
  /******/
})();
